module.exports = __webpack_public_path__ + "media/images/area/feature/okinawa/related/en_4-309c757b0307486655eb36b9d079784a.jpg";